<app-headers></app-headers>
<div class="container" @fadeIn @fadeOut>
  <router-outlet></router-outlet>
</div>
<app-modal></app-modal>
<app-footer></app-footer>
